document.addEventListener('DOMContentLoaded', () => {
    const headings = document.querySelectorAll('.cs-heading');
    if (!headings.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
        headings.forEach((heading) => heading.classList.add('is-visible'));
        return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
        });
    }, { threshold: 0.3, rootMargin: '0px 0px -10% 0px' });

    headings.forEach((heading) => observer.observe(heading));
});
